<template>
  <div>
     <v-container fluid id="admin-panel-reports">
       <v-row>
         <v-col cols="12" class="pa-0">
            <v-toolbar height="35px;" class="secondary">
              <v-toolbar-title>Reports</v-toolbar-title>
              <v-spacer/>
              <v-btn text 
                @click="$emit('clickedGoToDashboard')">
                <v-avatar size="24" class="mr-2">
                  <img :src="require('../../assets/' + coloredAssetUrls.returnToAdmin)" />
                </v-avatar>Return To Adminstrator Center Dashboard
              </v-btn>
            </v-toolbar>
         </v-col>
       </v-row> 
       <v-row id="admin-panel-reports-body">
         <v-col cols="12" 
         xl="6" 
         class="report-forms">
           <v-row>
             <!--tabs-->
             <v-col cols="3">
                <v-tabs v-model="activeTab"
                  color="transparent"                 
                  vertical
                  fixed-tabs
                  grow
                  hide-slider
                  active-class="activeTab">                 
                  <v-tab
                    v-for="item in reportTabs"
                    :href="'#report-' + item.tab"
                    :key= "item.tab"
                    class="report-tab secondary"
                    @click="clearReportResult">
                    <img class="tab-logo" :src="item.image" />
                    <v-toolbar-title class="tab-text">
                     <span
                      :class="colorClass"
                      v-html="item.content"></span>
                    </v-toolbar-title>
                  </v-tab>
                </v-tabs>
             </v-col>
             <v-col cols="9">
              <!--exam summary form-->
              <v-tabs-items 
                v-model="activeTab" 
                id="report-exam"
                class="primary">
                <v-tab-item :value="'report-' + ReportTypes.Exam">
                  <div class="text-uppercase mb-5">Report Criteria</div>
                    <v-form>
                      <!--form header-->
                      <v-row class="headerRow">
                        <v-col cols="2">
                          Show
                        </v-col>
                        <v-col cols="4">
                          Attribute
                        </v-col>
                        <v-col cols="6">
                          Criteria
                        </v-col>
                      </v-row>
                      <!--date range-->
                      <v-row>
                        <v-col cols="2">
                          <v-radio-group
                            v-model="examSummaryReport.reportGroupBy"
                            row>
                            <v-radio
                              :value= this.showExamSummaryColumns[0].value
                              :color="colorHex" />
                          </v-radio-group>
                        </v-col>
                        <v-col cols="4" class="attribute-text">
                          <span :class="colorClass">Date Range</span>
                        </v-col>
                        <v-col cols="6">
                          <v-row no-gutters>
                            <v-col cols="6">
                              <date-menu
                                :value="examSummaryReport.dateFrom"
                                @change="setExamSummaryDateFrom"
                                name="examSummaryReport.dateFrom"
                                v-validate="'required|date|'"
                                data-vv-as="From"/>
                            </v-col>
                            <v-col cols="6">
                              <date-menu
                                :value="examSummaryReport.dateTo"
                                @change="setExamSummaryDateTo"
                                name="examSummaryReport.dateTo"
                                v-validate="'required|date|'"
                                data-vv-as="To"/>
                            </v-col>
                          </V-row>
                        </v-col>
                      </v-row>
                      <!--exam type-->
                      <v-row>
                        <v-col cols="2">
                          <v-radio-group
                            v-model="examSummaryReport.reportGroupBy"
                            row>
                            <v-radio
                              :value= this.showExamSummaryColumns[1].value
                              :color="colorHex" />
                          </v-radio-group>
                        </v-col>
                        <v-col cols="4" class="attribute-text">
                          <span :class="colorClass">Exam Type</span>
                        </v-col>
                        <v-col cols="6">
                        <select-with-button
                          class="select-btn"
                          v-model="examSummaryReport.device"
                          :items="sortedDevices"
                          name="examSummaryReport.device"
                          data-vv-as="examSummaryReport.device"
                          placeholder="All"
                          multiple/>
                        </v-col>
                      </v-row>
                       <!--devtypes-->
                      <v-row>
                        <v-col cols="2">
                          <v-radio-group
                            v-model="examSummaryReport.reportGroupBy"
                            row>
                            <v-radio
                              :value= this.showExamSummaryColumns[2].value
                              :color="colorHex" />
                          </v-radio-group>
                        </v-col>
                        <v-col cols="4" class="attribute-text">
                          <span :class="colorClass">Device Type</span>
                        </v-col>
                        <v-col cols="6">
                        <select-with-button
                          class="select-btn"
                          v-model="examSummaryReport.devTypes"
                          :items="devTypes"
                          name="examSummaryReport.devtypes"
                          data-vv-as="examSummaryReport.devtypes"
                          placeholder="ALL"
                          multiple/>
                        </v-col>
                      </v-row>
                      <!--devLocations-->
                      <v-row>
                        <v-col cols="2">
                          <v-radio-group
                            v-model="examSummaryReport.reportGroupBy"
                            row>
                            <v-radio
                              :value= this.showExamSummaryColumns[3].value
                              :color="colorHex" />
                          </v-radio-group>
                        </v-col>
                        <v-col cols="4" class="attribute-text">
                          <span :class="colorClass">Location</span>
                        </v-col>
                        <v-col cols="6">
                        <select-with-button
                          class="select-btn"
                          v-model="examSummaryReport.devLocations"
                          :items="devLocations"
                          name="examSummaryReport.devLocations"
                          data-vv-as="examSummaryReport.devLocations"
                          placeholder="ALL"
                          multiple/>
                        </v-col>
                      </v-row>
                      <!--physician-->
                      <v-row>
                        <v-col cols="2">
                         <v-radio-group
                            v-model="examSummaryReport.reportGroupBy"
                            row>
                            <v-radio
                              :value= this.showExamSummaryColumns[4].value
                              :color="colorHex" />
                          </v-radio-group>
                        </v-col>
                        <v-col cols="4" class="attribute-text">
                          <span :class="colorClass">Physician</span>
                        </v-col>
                        <v-col cols="6">
                        <select-with-button
                          class="select-btn"
                          v-model="examSummaryReport.physician"
                          :items="sortedPhysicians"
                          name="examSummaryReport.physician"
                          data-vv-as="examSummaryReport.physician"
                          placeholder="ALL"
                          multiple/>
                        </v-col>
                      </v-row>
                      <!--dictated cases-->
                      <v-row>
                        <v-col cols="2">
                          <v-radio-group
                            v-model="examSummaryReport.reportGroupBy"
                            row>
                            <v-radio
                              :value= this.showExamSummaryColumns[5].value
                              :color="colorHex" />
                          </v-radio-group>
                        </v-col>
                        <v-col cols="4" class="attribute-text">
                          <span :class="colorClass">Dictated Cases</span>
                        </v-col>
                        <v-col cols="6">
                        <select-with-button
                          class="select-btn"
                          v-model="examSummaryReport.dictated"
                          :items="BoolAndEither"
                          name="examSummaryReport.dictated"
                          data-vv-as="examSummaryReport.dictated"/>
                        </v-col>
                      </v-row>
                      <!--teaching-->
                      <v-row>
                        <v-col cols="2">
                          <v-radio-group
                            v-model="examSummaryReport.reportGroupBy"
                            row>
                            <v-radio
                              :value= this.showExamSummaryColumns[6].value
                              :color="colorHex" />
                          </v-radio-group>
                        </v-col>
                        <v-col cols="4" class="attribute-text">
                          <span :class="colorClass">Teaching/Research Cases</span>
                        </v-col>
                        <v-col cols="6">
                        <select-with-button
                          class="select-btn"
                          v-model="examSummaryReport.teaching"
                          :items="BoolAndEither"
                          name="examSummaryReport.teaching"
                          data-vv-as="examSummaryReport.teaching"/>
                        </v-col>
                      </v-row>
                      <!--diagnosis-->
                      <v-row>
                        <v-col cols="2">
                         <v-radio-group
                            v-model="examSummaryReport.reportGroupBy"
                            row>
                            <v-radio
                              :value= this.showExamSummaryColumns[7].value
                              :color="colorHex" />
                          </v-radio-group>
                        </v-col>
                        <v-col cols="4" class="attribute-text">
                          <span :class="colorClass">Diagnosis</span>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                          type="text"
                          v-model="examSummaryReport.examPathology"
                          name="examSummaryReport.examPathology"
                          data-vv-as="examSummaryReport.examPathology"
                          solo/>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-btn class="modal-cta" @click.stop.prevent="clearshow">Clear Show</v-btn>
                        </v-col>
                        <v-col cols="6">
                          <v-btn class="modal-cta" @click.stop.prevent="clickedSubmitExamSummary">Submit</v-btn>
                        </v-col>
                      </v-row>               
                    </v-form>
                </v-tab-item>
              </v-tabs-items>
                <!--user activity form-->
              <v-tabs-items 
                v-model="activeTab" 
                id="report-user"
                class="primary">
                <v-tab-item :value="'report-' + ReportTypes.User">
                  <v-form>
                    <!--form header-->
                    <v-row class="headerRow">
                      <v-col cols="6">
                        Attribute
                      </v-col>
                      <v-col cols="6">
                        Criteria
                      </v-col>
                    </v-row>
                    <!--date range-->
                    <v-row>
                      <v-col cols="6" class="attribute-text">
                        <span :class="colorClass">Date Range</span>
                      </v-col>
                      <v-col cols="6">
                        <v-row no-gutters>
                          <v-col cols="6">
                            <date-menu
                            :value="userActivityReport.dateFrom"
                            @change="setuserActivityDateFrom"
                            name="userActivityReport.dateFrom"
                            v-validate="'required|date|'"
                            data-vv-as="userActivityReport.dateFrom"/>
                          </v-col>
                          <v-col cols="6">
                            <date-menu
                            :value="userActivityReport.dateTo"
                             @change="setuserActivityDateTo"
                            name="userActivityReport.dateTo"
                            v-validate="'required|date|'"
                            data-vv-as="userActivityReport.dateTo"/>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <!--user-->
                    <v-row>
                      <v-col cols="6" class="attribute-text">
                        <span :class="colorClass">User*</span>
                      </v-col>
                      <v-col cols="6">
                        <select-with-button
                          class="inputField"
                          v-model="userActivityReport.usrSrNo"
                          :items="activityReportSortedUsers"
                          item-value="value"
                          item-text="text"
                          name="userActivityReport.usrSrNo"
                          v-validate="'required'"
                          data-vv-as="userActivityReport.usrSrNo"/>
                      </v-col>
                    </v-row>
                    <!--activity-->
                    <v-row>
                      <v-col cols="6" class="attribute-text">
                        <span :class="colorClass">Activity</span>
                      </v-col>
                      <v-col cols="6">
                        <select-with-button
                          class="inputField"
                          v-model="userActivityReport.userActivities"
                          :items="UserActivities"
                          item-value="value"
                          item-text="text"
                          name="userActivityReport.userActivities"
                          data-vv-as="userActivityReport.userActivities"
                          multiple/>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-btn class="modal-cta" @click.stop.prevent="clickedSubmitUserActivity">Submit</v-btn>
                      </v-col>
                    </v-row>   
                  </v-form>
                </v-tab-item>
              </v-tabs-items>
                <!--device history form-->
              <v-tabs-items 
                v-model="activeTab" 
                id="report-device"
                class="primary">
                <v-tab-item :value="'report-' + ReportTypes.Device">
                  <v-form>
                    <!--form header-->
                    <v-row class="headerRow">
                      <v-col cols="6">
                        Attribute
                      </v-col>
                      <v-col cols="6">
                        Criteria
                      </v-col>
                    </v-row>
                    <!--date range-->
                    <v-row>
                      <v-col cols="6" class="attribute-text">
                        <span :class="colorClass">Date Range</span>
                      </v-col>
                      <v-col cols="6">
                        <v-row no-gutters>
                          <v-col cols="6">
                            <date-menu
                            :value="deviceHistoryReport.dateFrom"
                            @change="setDeviceHistoryDateFrom"
                            name="deviceHistoryReport.dateFrom"
                            v-validate="'required|date|'"
                            data-vv-as="deviceHistoryReport.dateFrom"/>
                          </v-col>
                          <v-col cols="6">
                            <date-menu
                            :value="deviceHistoryReport.dateTo"
                             @change="setDeviceHistoryDateTo"
                            name="deviceHistoryReport.dateTo"
                            v-validate="'required|date|'"
                            data-vv-as="deviceHistoryReport.dateTo"/>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <!--devices-->
                    <v-row>
                      <v-col cols="6" class="attribute-text">
                        <span :class="colorClass">Exam Type (Dev Proc)</span>
                      </v-col>
                      <v-col cols="6">
                        <select-with-button
                          class="inputField"
                          v-model="deviceHistoryReport.devices"
                          :items="deviceReportsortedDevices"
                          item-value="value"
                          item-text="text"
                          name="deviceHistoryReport.devices"
                          data-vv-as="deviceHistoryReport.devices"
                          placeholder="All"
                          multiple/>
                      </v-col>
                    </v-row>
                    <!--user-->
                    <v-row>
                      <v-col cols="6" class="attribute-text">
                        <span :class="colorClass">User</span>
                      </v-col>
                      <v-col cols="6">
                        <select-with-button
                          class="inputField"
                          v-model="deviceHistoryReport.users"
                          :items="deviceReportSortedUsers"
                          item-value="value"
                          item-text="text"
                          name="deviceHistoryReport.usrSrNo"
                          data-vv-as="deviceHistoryReport.usrSrNo"
                          multiple/>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-btn class="modal-cta" @click.stop.prevent="clickedSubmitDeviceHistory">Submit</v-btn>
                      </v-col>
                    </v-row>   
                  </v-form>
                </v-tab-item>
              </v-tabs-items>
             </v-col>
           </v-row>
         </v-col>
          <v-col cols="12" xl="6">
            <admin-panel-reports-result 
              v-if="!resetTable"
              :reportResult="ReportResult"
              :reportType="activeTab"
              @updateReport="updateReport"
              @exportPDF="exportPDF"
              @exportCSV="exportCSV"/>
         </v-col>
       </v-row>      
     </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {ReportTypes, UserActivities, BoolAndEither, GROUP_BY} from "../../config/config.js";
import { displayDateFormat } from "../../helpers/dateUtils";
import moment from "moment";
import dateMenu from "../controls/DateMenu";
import selectWithButton from "../../components/controls/SelectWithButton";
import AdminPanelReportsResult from "./AdminPanelReportsResult";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { isoDateTimeFormat } from "../../helpers/dateUtils";
export default {
  name: "AdminPanelReports",
  components: {
    dateMenu,
    selectWithButton,
    AdminPanelReportsResult
  },
  data(){
    return{
      resetTable: false,
      users: [],
      ReportTypes: ReportTypes,
      UserActivities: UserActivities,
      BoolAndEither: BoolAndEither,
      activeTab: "report-" + ReportTypes.Exam,
      reportTabs:[
        {tab: ReportTypes.Exam, content: "Exam<br>Summary<br>Reports", image: require("../../assets/Exams.svg")},
        {tab: ReportTypes.User, content: "User<br>Activity<br>Reports", image: require("../../assets/Users.svg")},
        {tab: ReportTypes.Device, content: "Device<br>History<br>Reports", image: require("../../assets/Exams.svg")}
      ],
      examSummaryReport:{
        dateFrom: new Date().toISOString().substr(0, 10),
        dateTo: new Date().toISOString().substr(0, 10),
        device: [],
        physician: [],
        dictated: null,
        teaching: null,
        examPathology: "",
        devTypes: [],
        devLocations: [],
        reportGroupBy: 0,
        pageNumber: 1,
        rowPerPage: 15
      },
      userActivityReport:{
        usrSrNo:0,
        userActivities: [],
        dateFrom: new Date().toISOString().substr(0, 10),
        dateTo: new Date().toISOString().substr(0, 10),
        pageNumber: 1,
        rowPerPage: 15
      },
      deviceHistoryReport:{
        users: [],
        devices: [],
        dateFrom: new Date().toISOString().substr(0, 10),
        dateTo: new Date().toISOString().substr(0, 10),
        pageNumber: 1,
        rowPerPage: 15
      },
      ReportResult:{
        reportSummary:"",
        showColumn:[],
        data: [],
        message: "",
        total: []
      },
      ExportResult:{
        reportSummary:"",
        showColumn:[],
        data: [],
        message: "",
        total: []
      },
      showExamSummaryColumns:[
        {text: "Exam Date" , value: GROUP_BY.exDateTime, visible: false, name: "groupBy"},
        {text: "Exam Type" , value : GROUP_BY.exDevProc, visible: false, name: "groupBy"},
        {text: "Device Type" , value: GROUP_BY.devType, visible: false, name: "groupBy"},
        {text: "Location" , value: GROUP_BY.devLocation, visible: false, name: "groupBy"},
        {text: "Physician" , value: GROUP_BY.phySrNo, visible: false, name: "groupBy"},
        {text: "Dictated Cases" , value: GROUP_BY.exDictated, visible: false, name: "groupBy"},  
        {text: "Teaching/Research Cases" , value: GROUP_BY.exIsStudy, visible: false, name: "groupBy"}, 
        {text: "Diagnosis" , value: GROUP_BY.pathNote, visible: false, name: "groupBy"}, 
        {text: "Total Patients" , value: 99, visible: true, name: "totalPatients"}, 
        {text: "Total Exams" , value: 100, visible: true, name: "totalExams"}, 
        {text: "Total Images" , value: 101, visible: true, name: "totalImages"}, 
      ],
      showUserActivityReportColumns: [
        {text: "Date/Time" , name: "hplTmStamp", visible: true},
        {text: "Activity" , name : "activity", visible: true},
        {text: "Patient Last Name" , name: "patientLname", visible: true},
        {text: "Patient First Name" , name: "paitentFname", visible: true},
        {text: "Patient ID" , name: "patientID", visible: true},
        {text: "Exam ID Number" , name: "examID", visible: true},
      ],
      showDeviceHistoryReportColumns: [
        {text: "Date/Time" , name: "tmStamp", visible: true},
        {text: "Exam Type (Dev Proc)" , name : "devProc",  visible: true},
        {text: "User" , name: "username",  visible: true},
        {text: "Field" , name: "field",  visible: true},
        {text: "OldValues" , name: "oldValues", visible: true},
        {text: "NewValues" , name: "newValues", visible: true},
      ]
    }
  },
  methods:{
    exportTitle() {
      return this.activeTab == "report-1" ? "AXIS User Activity Report" : "AXIS Exam Summary Report";
    },
    updateReport(options){
      if (this.activeTab == "report-" + ReportTypes.User) {
        this.updateUserActivityReport(options);
      }
      else if (this.activeTab == "report-" + ReportTypes.Exam) {
        this.updateExamSummaryReport(options)
      }
      else if (this.activeTab == "report-" + ReportTypes.Device) {
        this.updateDeviceHistoryReport(options)
      }
    },
    clearReportResult(){
      this.ReportResult.reportSummary = "";
      this.ReportResult.showColumn = [];
      this.ReportResult.data =[];
      this.ReportResult.message = "",
      this.ReportResult.total = [],
      this.ReportResult.totalCount = 0
    },
    clearshow(){
      this.examSummaryReport.reportGroupBy = 0;
    },
    updateExamSummaryReport(options){
      this.examSummaryReport.pageNumber = options.page,
      this.examSummaryReport.rowPerPage = options.rowPerPage
      this.submitExamSummary(this.examSummaryReport, this.ReportResult);
    },
    clickedSubmitExamSummary(){
      this.resetTable = true;
      this.examSummaryReport.pageNumber = 1,
      this.examSummaryReport.rowPerPage = 15
      this.submitExamSummary(this.examSummaryReport, this.ReportResult);
    },
    submitExamSummary(search, result, callback){
      this.$store.commit("setLoadingMessage", "Loading...");
      this.$store
      .dispatch("submitExamSummaryReport", search).then(response => {
          if(response && response.data && response.data.success == false){
            result.message = "The date range selected is too large to report results within the Administration Center interface; please try selecting a smaller date range. If required, larger reports may be generated from with the SQL Server database itself; please contact the AXIS Support Team for further information.";
            this.resetTable = false;
          }
          else if(response && response.data.data.page.examSummaries.length > 0){
            result.data = this.setExamSummaryGroupDisplay(response.data.data.page.examSummaries, this.examSummaryReport.reportGroupBy);
            result.total =  [{total: "Total", patientsTotal : response.data.data.totalPatients, examTotal: response.data.data.totalExams, imageTotal: response.data.data.totalImages}];
            result.showColumn = this.setExamSummaryReportColumns(this.examSummaryReport.reportGroupBy);
            result.reportSummary = response.data.data.summaryReport;
            result.totalCount = response.data.data.totalCount;
            this.resetTable = false;
            if(typeof callback === "function"){
              callback(result);
            }         
          }else{
            result.message = "No data found";
            result.data = [];  //clear previous result
            this.resetTable = false;
          }
        }).finally(() => this.$store.commit("setLoadingMessage", null));

    },
    updateUserActivityReport(options){
      this.userActivityReport.pageNumber = options.page,
      this.userActivityReport.rowPerPage = options.rowPerPage
      this.submitUserActivity(this.userActivityReport, this.ReportResult);
    },
    clickedSubmitUserActivity(){
      this.resetTable = true;
      this.userActivityReport.pageNumber = 1,
      this.userActivityReport.rowPerPage = 15
      this.submitUserActivity(this.userActivityReport, this.ReportResult);
    },
    submitUserActivity(search, result, callback){
      if(this.userActivityReport.usrSrNo == 0){
        this.$store.commit("displayStatus", { message: "Please select a user", level: "error" });
      }else{
        this.$store.commit("setLoadingMessage", "Loading...");
        this.$store
        .dispatch("submitUserActivityReport",search).then(response => {        
          if(response && response.data.data.list.length > 0){
            result.data = response.data.data.list;
            result.showColumn = this.showUserActivityReportColumns.filter(a => a.visible);
            result.reportSummary = this.getUserActivitySummary();
            result.total = null;
            result.totalCount = response.data.data.totalCount;
            this.resetTable = false;
            if(typeof callback === "function"){
              callback(result);
            }         
          }else{          
            result.message = "No data found";
          }
        }).finally(() => this.$store.commit("setLoadingMessage", null));
      }     
    },
    updateDeviceHistoryReport(options){
      this.deviceHistoryReport.pageNumber = options.page,
      this.deviceHistoryReport.rowPerPage = options.rowPerPage
      this.submitDeviceHistory(this.deviceHistoryReport, this.ReportResult);
    },
    clickedSubmitDeviceHistory(){
      this.resetTable = true;
      this.deviceHistoryReport.pageNumber = 1,
      this.deviceHistoryReport.rowPerPage = 15
      this.submitDeviceHistory(this.deviceHistoryReport, this.ReportResult);
    },
    submitDeviceHistory(search, result, callback){
      this.$store.commit("setLoadingMessage", "Loading...");
      this.$store
      .dispatch("submitDeviceHistory",search).then(response => {        
        if(response && response.data.data.list.length > 0){
          let changes = this.processDeviceHistoryChanges(response.data.data.list);
          let startIndex = (response.data.data.pageNumber - 1) * response.data.data.rowPerPage;
          let endIndex = (response.data.data.pageNumber * response.data.data.rowPerPage);
          result.data = response.data.data.rowPerPage != 0 ? changes.slice(startIndex, endIndex) : changes;
          result.showColumn = this.showDeviceHistoryReportColumns.filter(a => a.visible);
          result.reportSummary = this.getDeviceHistorySummary();
          result.total = null;
          result.totalCount = changes.length;
          this.resetTable = false;
          if(typeof callback === "function"){
            callback(result);
          }         
        }else{          
          result.message = "No data found";
        }
      }).finally(() => this.$store.commit("setLoadingMessage", null));
    },
    processDeviceHistoryChanges(historyData) 
    {
      
      this.deviceHistoryReport.pageNumber = 1,
      this.deviceHistoryReport.rowPerPage = 15
      let changes = [];
      for (var i = 0; i < historyData.length; i++) 
      {
        for (var j = 0; j < historyData[i].changes.length; j++)
          changes.push(historyData[i].changes[j]);
      }
      return changes;
    },
    setExamSummaryGroupDisplay(reportData, reportGroupBy){
      if(reportGroupBy == GROUP_BY.none){
         return reportData;
      }
      let formattedReportData = [];
      switch(reportGroupBy){
        case GROUP_BY.exDevProc:
          formattedReportData = this.formatReportExType(reportData);
          break;
        case GROUP_BY.exDateTime:
          formattedReportData = this.formatReportExDateTime(reportData);
          break;
        case GROUP_BY.phySrNo:
          formattedReportData = this.formatReportPhysicianName(reportData);
          break;
        case GROUP_BY.exDictated:
          formattedReportData = this.formatReportBoolToString(reportData);
          break;
        case GROUP_BY.exIsStudy:
          formattedReportData = this.formatReportBoolToString(reportData);
          break;
        default:
          formattedReportData = reportData;
          break;
      }
      return formattedReportData;
    },
    formatReportBoolToString(reportData){
       for(let i = 0; i < reportData.length; i++){
        reportData[i].groupBy = reportData[i].groupBy == true ? "Yes" : "No";
      }
      return reportData;
    },
    formatReportExType(reportData){
      for(let i = 0; i < reportData.length; i++){
        let dev = this.sortedDevices.find(x => x.value.devSrNo == reportData[i].groupBy);
        reportData[i].groupBy = dev.text;
      }
      return reportData;
    },
    formatReportExDateTime(reportData){
      for(let i = 0; i < reportData.length; i++){
        reportData[i].groupBy = moment(reportData[i].groupBy).format(displayDateFormat);
      }
      return reportData;
    },
    formatReportPhysicianName(reportData){
      for(let i = 0; i < reportData.length; i++){
        let physician =  this.sortedPhysicians.find(x => x.value.phySrNo == reportData[i].groupBy);
        if(physician){
          reportData[i].groupBy = physician.text;
        }
        else{
          reportData[i].groupBy = "No Physician";
        }
      }
      return reportData;
    },
    setExamSummaryReportColumns(reportGroupBy){
      if(reportGroupBy == GROUP_BY.none){
        return this.showExamSummaryColumns.filter(a => a.visible);
      }
      let finalColumns = JSON.parse(JSON.stringify(this.showExamSummaryColumns)); // this.showExamSummaryColumns

      for (let i = 0; i < finalColumns.length; i++) {
        if(finalColumns[i].value == reportGroupBy){
          finalColumns[i].visible = true;
          break;
        }    
      }
      return finalColumns.filter(a => a.visible);
    },
    getUserActivitySummary(){
      let selectedUser = this.users.filter(a => a.srNo === this.userActivityReport.usrSrNo);
      let selectedActivites = this.userActivityReport.userActivities;
      let activities = UserActivities.filter(function(item){
        return selectedActivites.includes(item.value);
      }).map(a => a.text).join(", ");

      let selectedActivitesString = activities == "" ? "All activities" : "Activity: " + activities;
      let dateFrom = moment(this.userActivityReport.dateFrom).format(displayDateFormat);
      let dateTo = moment(this.userActivityReport.dateTo).format(displayDateFormat);
      let selectedUserName = selectedUser[0].fName + " " + selectedUser[0].lName;

      return "User: " + selectedUserName + "; " + dateFrom +" to " + dateTo + "; " + selectedActivitesString;
    },
    getDeviceHistorySummary(){
      let selectedUsers = this.deviceHistoryReport.users;
      let users = this.deviceReportSortedUsers.filter(function(item){
        return selectedUsers.includes(item.value);
      }).map(a => a.text).join(", ");
      let selectedUsersString = users == "" ? "All users" : "Users: " + users;

      let selectedDevices = this.deviceHistoryReport.devices;
      let devices = this.deviceReportsortedDevices.filter(function(item){
        return selectedDevices.includes(item.value);
      }).map(a => a.text).join(", ");

      let selectedDevicesString = devices == "" ? "All devices" : "Devices: " + devices;
      let dateFrom = moment(this.deviceHistoryReport.dateFrom).format(displayDateFormat);
      let dateTo = moment(this.deviceHistoryReport.dateTo).format(displayDateFormat);

      return selectedUsersString + "; " + dateFrom +" to " + dateTo + "; " + selectedDevicesString;
    },
    setExamSummaryDateFrom(value){
      this.$set(this.examSummaryReport, "dateFrom", value);
    },
    setExamSummaryDateTo(value){
      this.$set(this.examSummaryReport, "dateTo", value);
    },
    setuserActivityDateFrom(value){
      this.$set(this.userActivityReport, "dateFrom", value);
    },
    setuserActivityDateTo(value){
      this.$set(this.userActivityReport, "dateTo", value);
    },
    setDeviceHistoryDateFrom(value){
      this.$set(this.deviceHistoryReport, "dateFrom", value);
    },
    setDeviceHistoryDateTo(value){
      this.$set(this.deviceHistoryReport, "dateTo", value);
    },
    getDateTimeNowInt(){
      var dateTime = moment().format(isoDateTimeFormat);
      dateTime = dateTime.replace(/-/g, "").replace(/:/g,"").replace(/ /g,"");
      return dateTime;
    },
    exportPDF(){
      // this is a temporary fix for exam summary report since server side paging is on hold
      if(this.activeTab == "report-" + ReportTypes.Exam){
        let search = Object.assign({}, this.examSummaryReport);
        search.rowPerPage = 0;  // 0 = all
        this.submitExamSummary(search, this.ExportResult, this.generatePDF);    
      }
      else if (this.activeTab == "report-" + ReportTypes.User) {
        // pull all data for user activity export
        let search = Object.assign({}, this.userActivityReport);
        search.rowPerPage = 0;  // 0 = all
        this.submitUserActivity(search, this.ExportResult, this.generatePDF);    
      }
      else if (this.activeTab == "report-" + ReportTypes.Device) {
        // pull all data for user activity export
        let search = Object.assign({}, this.deviceHistoryReport);
        search.rowPerPage = 0;  // 0 = all
        this.submitDeviceHistory(search, this.ExportResult, this.generatePDF);    
      }
    }, 
    generatePDF(thisData){
      let header = [];
      let headerRow =  thisData.showColumn.map(a => a.text);
      let headerNames = thisData.showColumn.map(a => a.name);
      header.push(headerRow);
      let bodyContent = [];
      thisData.data.forEach(function(item){
        let row = [];
        for(let i = 0; i < headerNames.length; i++){
          row.push(item[headerNames[i]]);
        }
        bodyContent.push(row);
      })
      if(thisData.total && thisData.total.length > 0){
        let row = [];
        row.push(thisData.total[0]["total"]);
        row.push(thisData.total[0]["patientsTotal"]);
        row.push(thisData.total[0]["examTotal"]);
        row.push(thisData.total[0]["imageTotal"]);
        bodyContent.push(row);
      }

      let doc = new jsPDF();
      doc.setFillColor(43, 43, 43);
      doc.rect(2, 2, 206, 12, "F");
      doc.addImage(window.document.getElementById("sonomed"), "png", 4, 2, 45, 10);
      doc.addImage(window.document.getElementById("axis"), "png", 175, 1, 30, 15);
      doc.text(this.exportTitle(), 4, 24);
      doc.setFontSize(8);
      let wrappedText = doc.splitTextToSize(thisData.reportSummary, 200);
      doc.text(wrappedText, 4, 28);
      if (headerNames.includes("oldValues")) 
        autoTable(doc, {
          headStyles: {fillColor: [71, 71, 71]},
          head: header,
          body: bodyContent,
          margin: {top: 44},
          columnStyles: {
            0: {cellWidth: 20},
            1: {cellWidth: 20},
            2: {cellWidth: 20},
            3: {cellWidth: 20},
            4: {cellWidth: 50},
            5: {cellWidth: 50},
          }
        });
      else
        autoTable(doc, {
          headStyles: {fillColor: [71, 71, 71]},
          head: header,
          body: bodyContent,
          margin: {top: 44}
        });
      // Drawing header on subsequent pages if page count > 1
      for (let i = 1; i < doc.lastAutoTable.pageCount; i++) {
        doc.movePage(i + 1, i);
        doc.rect(2, 2, 206, 12, "F");
        doc.addImage(window.document.getElementById("sonomed"), "png", 4, 2, 45, 10);
        doc.addImage(window.document.getElementById("axis"), "png", 175, 1, 30, 15);
        doc.setFontSize(16);
        doc.text("AXIS Exam Summary Report", 4, 24);
        doc.setFontSize(8);
        let wrappedText = doc.splitTextToSize(thisData.reportSummary, 200);
        doc.text(wrappedText, 4, 28);
      }
      if (doc.lastAutoTable.pageCount > 1)
        doc.movePage(doc.lastAutoTable.pageCount, 1);
      doc.save(this.getDateTimeNowInt() + ".pdf");
    },
    exportCSV(){
       // this is a temporary fix for exam summary report since server side paging is on hold
      if(this.activeTab == "report-" + ReportTypes.Exam){
        let search = Object.assign({}, this.examSummaryReport);
        search.rowPerPage = 0;  // 0 = all
        this.submitExamSummary(search, this.ExportResult, this.generateCSV);    
      }
      else if (this.activeTab == "report-" + ReportTypes.User) {
        // pull all data for user activity export
        let search = Object.assign({}, this.userActivityReport);
        search.rowPerPage = 0;  // 0 = all
        this.submitUserActivity(search, this.ExportResult, this.generateCSV);    
      }
      else if (this.activeTab == "report-" + ReportTypes.Device) {
        let search = Object.assign({}, this.deviceHistoryReport);
        search.rowPerPage = 0;  // 0 = all
        this.submitDeviceHistory(search, this.ExportResult, this.generateCSV);    
      }
    },
    generateCSV(thisData){
      let csv = "data:text/csv;charset=utf-8,";
      let csvData = "";
      let headerNames = thisData.showColumn.map(a => a.name);

      thisData.data.forEach(function(item){
        let line = "";

        for(let i = 0; i < headerNames.length; i ++){
          if(line !="") line +=",";

            line += "\"" +item[headerNames[i]] + "\"";
        }     
        csvData += line + "\r\n";
      })

      if(thisData.total && thisData.total.length > 0){
        let line = "";
        line += "\"" + thisData.total[0]["total"] + "\"" + ",";
        line += "\"" + thisData.total[0]["patientsTotal"] + "\"" + ",";
        line += "\"" + thisData.total[0]["examTotal"] + "\"" + ",";
        line += "\"" + thisData.total[0]["imageTotal"] + "\"" ;
        csvData += line + "\r\n";
      }

      let reportSummary = thisData.reportSummary.replace(/,/g, ";");
      let csvHeader = this.exportTitle() + "\n" + reportSummary + "\n\n" + thisData.showColumn.map(a => a.text).join(",") + "\r\n";
      let csvContent = csv + csvHeader + csvData; 
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", this.getDateTimeNowInt() + ".csv");
      document.body.appendChild(link);
      link.click();
    }
  },
  computed:{
    ...mapGetters([ "devices", "devTypes", "devLocations", "physicians", "siteInfo"]),
    addEditDeviceUI() {
      return this.siteInfo.addEditDeviceUI;
    },
    sortedDevices() {
      return [...this.devices]
        .sort((a, b) =>{
          let proA = a.procedure.toLowerCase(), 
          proB = b.procedure.toLowerCase();
          return proA < proB ? -1 : proA > proB ? 1 : 0;
        })
        .map(d => {
          return { value: d, text: d.procedure };
        });
    },
    sortedPhysicians() {
      return [...this.physicians]
        .sort((a, b) => {
          let nA = a.name.toLowerCase(),
            nB = b.name.toLowerCase();
          return nA < nB ? -1 : nA > nB ? 1 : 0;
        })
        .map(p => {
          return { value: p, text: p.name };
        });
    }, 
    deviceReportsortedDevices() {
      return [...this.devices]
        .sort((a, b) =>{
          let proA = a.procedure.toLowerCase(), 
          proB = b.procedure.toLowerCase();
          return proA < proB ? -1 : proA > proB ? 1 : 0;
        })
        .map(d => {
          return { value: d.devSrNo, text: d.procedure };
        });
    },
    activityReportSortedUsers() {
      let sortedusers =  [...this.users]
        .sort((a, b) => {
          let nA = a.name.toLowerCase(),
            nB = b.name.toLowerCase();
          return nA < nB ? -1 : nA > nB ? 1 : 0;
        })
        .map(u => {
          return { value: u.usrSrNo, text: u.name };
        });

        sortedusers = [{text: " ", value:{usrSrNo: 0}}].concat(sortedusers);
        return sortedusers;
    },
    deviceReportSortedUsers(){
      return[...this.users]
        .sort((a, b) => {
          let nA = a.name.toLowerCase(),
            nB = b.name.toLowerCase();
          return nA < nB ? -1 : nA > nB ? 1 : 0;
        })
        .map(u => {
          return { value: u.usrSrNo, text: u.name };
        });
    }
  },
  beforeMount() {
    this.$store.dispatch("getUserList")
    .then(response => {
      response.data.data.sort((a, b) => a.fName.localeCompare(b.fName))
      this.users = response.data.data;
      this.users.forEach(e => {
        e.name = e.fName + " " + e.lName;
      });
      if (!this.addEditDeviceUI)
        this.reportTabs = [
          {tab: ReportTypes.Exam, content: "Exam<br>Summary<br>Reports", image: require("../../assets/Exams.svg")},
          {tab: ReportTypes.User, content: "User<br>Activity<br>Reports", image: require("../../assets/Users.svg")}
        ];
    });
    this.$store.dispatch("getDevices");
  }
}
</script>
<style lang="scss" scoped>
  #admin-panel-reports{
    #admin-panel-reports-body{
      overflow: auto;
      height: calc( 100vh - 54px - 54px - 51px );
    }
    .report-tab{
        height: 180px;
    }
    .report-tab:not(:first-of-type){
      border-top: 1px;
      border-style: solid;
    }
    .tab-logo{
      height: calc(100vw /12);
    }
    .tab-text {
      position: absolute;
      font-weight: 700;
    }
    .activeTab {
      border-right: 1px solid white;
      .tab-text {
        color: $color-blue;
      }
     }
     .v-tabs{
       .v-slide-group__prev {
        display: none !important;
       }
     }
     
     .headerRow{
       border-bottom: 1px solid #FFFFFF;
     }
     .attribute-text{
       text-transform: uppercase;
     }
  } 
  @media screen and (min-width: 1905px){
    .report-forms{
      border-right: 1px solid #FFFFFF;
    }
  }
</style>


